module.exports = __webpack_public_path__ + "media/images/flags/vu-8f757fce2ead1f9cc90b82817d42572f.svg";